<template>
  <div class="page-content-mobile">
    <!-- 头部banner -->
    <div class="banner">
      <div class="introduce">
        <div class="introduce-title">
          让电商服务拥有「智慧温度」
        </div>
        <div class="introduce-desc">
          <div>七鼠智服——基于千亿大模型的AI客服系统</div>
          <div>为电商企业实现人力解放、体验升级与增长加速</div>
        </div>
      </div>
    </div>

    <!-- 统计板块 -->
    <div class="statistics-section">
      <div class="statistics-container">
        <div class="statistics-item" v-for="item in statisticsList" :key="item.title">
          <div class="statistics-value">{{ item.currentValue }}<span v-if="item.title !== '注册用户数量'">{{ item.title ===
            '问题处理率' || item.title === '客户满意度' || item.title === '释放人力' ? '%' : '' }}</span><span
              v-if="item.title === '注册用户数量'">+</span>
          </div>
          <div class="statistics-title">{{ item.title }}</div>
        </div>
      </div>
    </div>

    <!-- 产品介绍板块 -->
    <div class="product-section">
      <div class="product-content">
        <div class="product-title">关于七鼠智服</div>
        <div class="product-subtitle">一款接入千亿级大模型的电商AI智能客服系统</div>
        <div class="product-desc">
          精准锚定大型电商平台、中小型电商企业、新兴电商企业等核心客户群体。大型电商平台面临海量咨询压力，急需高效智能客服系统提升服务效率；中小型电商企业渴望以低成本实现服务升级；新兴电商企业则希望借助智能客服构建差异化竞争优势，这为我们提供了广阔的市场空间
        </div>
      </div>
      <div class="product-media">
        <div v-if="!productVideoPlaying" class="product-cover-wrap">
          <img :src="productCover" alt="产品介绍封面" class="product-cover-img" />
          <div class="product-play-btn" @click="playproductVideo">
            <svg viewBox="0 0 42 58" width="100%" height="100%">
              <polygon points="0,0 42,29 0,58" fill="#999" />
            </svg>
          </div>
        </div>
        <div v-else class="product-video-wrap">
          <video :src="productMp4" controls autoplay loop class="product-video" />
        </div>
      </div>
    </div>

    <!-- 板块1：多模态交互 × 智能应答 -->
    <div class="section-1">
      <div class="title-box">
        <div class="title-text">
          多模态交互 × 智能应答
        </div>
        <div class="title-line">
          支持图文音视全媒介交互的智能客服系统
        </div>
      </div>
      <div class="section1">
        <div class="section1-item" v-for="(item, index) in section1List" :key="item.title"
          :class="{ 'reverse': index % 2 === 1 }">
          <div class="section1-img-wrap">
            <img :src="item.img" :alt="item.title" class="section1-img" />
          </div>
          <div class="section1-content">
            <div class="section1-header">
              <div class="section1-num">{{ item.num }}</div>
              <div class="section1-title">{{ item.title }}</div>
            </div>
            <div class="section1-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 板块2：全维感知 × 决策中枢 -->
    <div class="section-2">
      <div class="title-box">
        <div class="title-text">
          全维感知 × 决策中枢
        </div>
        <div class="title-line">
          从精准理解到增长转化的AI服务引擎
        </div>
      </div>
      <div class="section2">
        <div class="function-item" v-for="(item, index) in functions" :key="index">
          <div class="function-img-wrap">
            <img :src="item.image" :alt="item.title" class="function-image" />
          </div>
          <div class="function-content">
            <div class="function-title">{{ item.title }}</div>
            <div class="function-desc">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 板块3：智能驱动 × 效能跃升 -->
    <div class="section-3">
      <div class="title-box">
        <div class="title-text">
          智能驱动 × 效能跃升
        </div>
        <div class="title-line">
          以AI技术重塑服务效率与体验的智能引擎
        </div>
      </div>
      <div class="section3">
        <div class="section3-item" v-for="item in section3List" :key="item.title">
          <div class="section3-icon-wrap">
            <img :src="item.img" :alt="item.title" class="section3-icon" />
            <div class="section3-title">{{ item.title }}</div>
          </div>
          <div class="section3-desc section3-desc1">{{ item.desc1 }}</div>
          <div class="section3-desc">{{ item.desc2 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import productCover from '../../assets/img/product/mobile/product_cover.png'
import productMp4 from '../../assets/video/product.mp4'

import section1mg1 from '../../assets/img/product/mobile/section1_img1.png'
import section1mg2 from '../../assets/img/product/mobile/section1_img2.png'
import section1mg3 from '../../assets/img/product/mobile/section1_img3.png'

import section3mg1 from '../../assets/img/product/pc/section3_img1.png'
import section3mg2 from '../../assets/img/product/pc/section3_img2.png'
import section3mg3 from '../../assets/img/product/pc/section3_img3.png'
import section3mg4 from '../../assets/img/product/pc/section3_img4.png'

export default {
  name: 'ProductIntroMobile',
  data() {
    return {
      // 统计数据
      statisticsList: [
        { title: '注册用户数量', value: 3000, currentValue: 0 },
        { title: '释放人力', value: 60, currentValue: 0 },
        { title: '问题处理率', value: 95, currentValue: 0 },
        { title: '客户满意度', value: 98.5, currentValue: 0 }
      ],

      // 产品介绍
      productVideoPlaying: false,
      productCover,
      productMp4,

      // 板块1
      section1mg1,
      section1mg2,
      section1mg3,

      section1List: [
        {
          num: '01',
          img: section1mg1,
          title: '图像识别与多媒体回复',
          desc: '用户可发送商品图片、截图等，智能客服精准识别内容，并主动回复图片、视频教程或商品示意图，沟通更直观高效。'
        },
        {
          num: '02',
          img: section1mg2,
          title: '语音消息实时解析',
          desc: '用户发送语音消息时，系统自动转写为文字并理解意图，支持方言识别，让不擅长打字的用户也能轻松沟通.'
        },
        {
          num: '03',
          img: section1mg3,
          title: '商品链接智能处理',
          desc: '用户发送商品链接后，客服自动解析商品信息（价格、库存、详情），并主动推荐关联商品链接或优惠活动，提升转化率。'
        }
      ],

      // 板块2
      functions: [
        {
          image: require('@/assets/img/product/pc/section2_img1.png'),
          title: 'AI全天自动模式',
          description: '基于行业知识图谱和上亿条金牌客服话术打造的电商客服专有模型，7*24 全天候待命，同时应对数干请求，智能答疑',
        },
        {
          image: require('@/assets/img/product/pc/section2_img2.png'),
          title: 'AI人机协同',
          description: 'AI客服自主处理常见问题，释放人力专注疑难需求;遇到难处理的问题，智能预警人工介入，提升服务质效，客户全程无感知',
        },
        {
          image: require('@/assets/img/product/pc/section2_img3.png'),
          title: '多平台聚合管理',
          description: '聚合多个电商平台的店铺管理，所有会话一个页面展示，无需来回切回店铺，高效管理所有平台数据',
        },
        {
          image: require('@/assets/img/product/pc/section2_img4.png'),
          title: 'AI自主营销',
          description: '深入剖析客户的行为数据、浏览历史、购买偏好等多维度信息，精准识别出客户的潜在需求和消费习惯，为每个客户量身定制营销内容',
        },
        {
          image: require('@/assets/img/product/pc/section2_img5.png'),
          title: 'AI情感感知',
          description: '基于自然语言处理（NLP）和机器学习技术，能够识别客户交流过程中所表达的情感，并根据这些情感信息调整回复的语气、内容和策略',
        },
        {
          image: require('@/assets/img/product/pc/section2_img6.png'),
          title: 'AI自主学习',
          description: '三分钟快速部署基础知识库，AI自主学习商品知识，构建完整的知识库体系，实现高效的知识沉淀和复用，一次配置，长期适用',
        },
      ],

      // 板块3
      section3List: [
        {
          img: section3mg1,
          title: '解放人力',
          desc1: '九成咨询自动化',
          desc2: '人效提升300%'
        },
        {
          img: section3mg2,
          title: '极速响应',
          desc1: '毫秒读懂需求',
          desc2: '回复零延迟抵达'
        },
        {
          img: section3mg3,
          title: '精准解答',
          desc1: '千亿模型训练',
          desc2: '标准问答准确率超98%'
        },
        {
          img: section3mg4,
          title: '体验升级',
          desc1: '个性化记忆推荐',
          desc2: '满意度提升复购持续增长'
        }
      ],
    }
  },
  methods: {
    playproductVideo() {
      this.productVideoPlaying = true;
    },
    animateNumber(idx, target, duration = 1000) {
      const start = 0;
      const isPercent = target <= 100;
      const end = target;
      const startTime = performance.now();
      const step = (now) => {
        const elapsed = now - startTime;
        let progress = Math.min(elapsed / duration, 1);
        let value = start + (end - start) * progress;
        if (isPercent) {
          value = Math.round(value * 10) / 10;
        } else {
          value = Math.floor(value);
        }
        this.$set(this.statisticsList, idx, {
          ...this.statisticsList[idx],
          currentValue: value
        });
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this.$set(this.statisticsList, idx, {
            ...this.statisticsList[idx],
            currentValue: end
          });
        }
      };
      requestAnimationFrame(step);
    }
  },
  mounted() {
    // 启动数字动画
    this.statisticsList.forEach((item, idx) => {
      setTimeout(() => {
        this.animateNumber(idx, item.value, 1500);
      }, idx * 200);
    });
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/mobile-responsive.scss' as mobile;

.page-content-mobile {
  @include mobile.mobile-page-content;
  background-color: #F5F7FB;

  // 头部banner
  .banner {
    width: 100%;
    height: mobile.px2rem(351);
    background: url('../../assets/img/product/mobile/banner.png') no-repeat center center;
    background-size: cover;
    text-align: center;
    margin-bottom: 0;

    .introduce {
      padding-top: mobile.px2rem(31);
      display: flex;
      flex-direction: column;
      align-items: center;

      .introduce-title {
        font-weight: bold;
        font-size: mobile.px2rem(24);
        color: #1D203D;
        margin-bottom: mobile.px2rem(8);
      }

      .introduce-desc {
        font-weight: 500;
        font-size: mobile.px2rem(14);
        color: #1D203D;
        text-align: left;
        line-height: mobile.px2rem(20);

        div {
          margin-bottom: mobile.px2rem(4);
        }
      }
    }
  }

  // 统计板块
  .statistics-section {
    position: relative;
    margin-top: mobile.px2rem(-44);
    // margin-bottom: mobile.px2rem(16);
    z-index: 10;

    .statistics-container {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 100%);
      box-shadow: 0px 2px 8px 0px rgba(38, 71, 124, 0.15);
      // box-shadow: 0 mobile.px2rem(8) mobile.px2rem(32) rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(mobile.px2rem(10));
      border-radius: 4px;
      padding: mobile.px2rem(18) mobile.px2rem(15);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .statistics-item {
        flex: 1;
        text-align: center;

        .statistics-value {
          font-weight: 800;
          font-size: mobile.px2rem(20);
          color: #333333;
          margin-bottom: mobile.px2rem(4);
        }

        .statistics-title {
          font-weight: 500;
          font-size: mobile.px2rem(14);
          color: #666;
        }
      }
    }
  }

  // 产品介绍板块
  .product-section {
    width: 100%;
    background: #FFFFFF;
    padding: mobile.px2rem(16) mobile.px2rem(15) mobile.px2rem(20) mobile.px2rem(15);
    margin-bottom: mobile.px2rem(24);
    margin-top: 16px;

    .product-content {
      text-align: center;
      margin-bottom: mobile.px2rem(8);

      .product-title {
        font-size: mobile.px2rem(20);
        line-height: mobile.px2rem(20);
        font-weight: 800;
        text-transform: none;
        background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
        margin-bottom: mobile.px2rem(8);
      }

      .product-subtitle {
        font-weight: 500;
        font-size: mobile.px2rem(14);
        color: #333;
        margin-bottom: mobile.px2rem(8);
      }

      .product-desc {
        font-weight: 500;
        font-size: mobile.px2rem(12);
        color: #6F6F6F;
        text-align: left;
      }
    }

    .product-media {
      border: mobile.px2rem(1) solid #0051FF;
      border-radius: 4px;
      overflow: hidden;
      width: 100%;
      height: mobile.px2rem(186);

      .product-cover-wrap {
        position: relative;
        width: 100%;
        height: 100%;

        .product-cover-img {
          width: 100%;
          height: 100%;
          display: block;
        }

        .product-play-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: mobile.px2rem(48);
          height: mobile.px2rem(48);
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;

          svg {
            width: mobile.px2rem(20);
            height: mobile.px2rem(20);
            margin-left: mobile.px2rem(2);
          }
        }
      }

      .product-video-wrap {
        width: 100%;
        border-radius: mobile.px2rem(8);
        overflow: hidden;

        .product-video {
          width: 100%;
          height: auto;
        }
      }
    }
  }



  // 板块1样式
  .section-1 {
    .title-box {
      background: #F5F7FB;
      text-align: center;

      .title-text {
        font-size: mobile.px2rem(20);
        font-weight: 800;
        color: #333333;
        margin-bottom: mobile.px2rem(8);
      }

      .title-line {
        font-size: mobile.px2rem(14);
        font-weight: 500;
        color: #333;
        margin-bottom: mobile.px2rem(17);
      }
    }

    .section1 {
      .section1-item {
        display: flex;
        align-items: center;
        margin-bottom: mobile.px2rem(12);
        gap: mobile.px2rem(12);
        background: #fff;
        box-sizing: border-box;
        padding: mobile.px2rem(20) mobile.px2rem(19) mobile.px2rem(12) 0;

        &:last-child {
          margin-bottom: 0;
        }

        // 奇数项（第2、4项）图片在右边
        &.reverse {
          flex-direction: row-reverse;
          padding: mobile.px2rem(20) 0 mobile.px2rem(12) mobile.px2rem(19);
        }

        .section1-img-wrap {
          flex-shrink: 0;
          width: mobile.px2rem(147);
          height: mobile.px2rem(80);

          .section1-img {
            width: 100%;
            height: 100%;
          }
        }

        .section1-content {
          flex: 1;

          .section1-header {
            display: flex;
            align-items: center;
            margin-bottom: mobile.px2rem(6);
            // gap: mobile.px2rem(8);

            .section1-num {
              font-size: mobile.px2rem(20);
              line-height: mobile.px2rem(20);
              font-weight: 800;
              background: linear-gradient(135deg, #00A1FF 30%, #0F3FFF 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              margin-right: mobile.px2rem(4);
            }

            .section1-title {
              font-size: mobile.px2rem(14);
              line-height: mobile.px2rem(14);
              font-weight: 800;
              color: #333;
            }
          }

          .section1-desc {
            font-weight: 500;
            font-size: mobile.px2rem(12);
            color: #666;
            text-align: left;
          }
        }
      }
    }
  }



  // 板块2样式
  .section-2 {
    padding: mobile.px2rem(24) mobile.px2rem(15) mobile.px2rem(20) mobile.px2rem(15);
    background: linear-gradient(135deg, #E5F7FF 0%, #F8FDFF 48%, #E5F7FF 100%);

    .title-box {
      text-align: center;
      margin-bottom: mobile.px2rem(16);

      .title-text {
        font-size: mobile.px2rem(20);
        font-weight: 800;
        color: #333333;
        margin-bottom: mobile.px2rem(8);
      }

      .title-line {
        font-size: mobile.px2rem(14);
        font-weight: 500;
        color: #333;
      }
    }

    .section2 {
      .function-item {
        margin-bottom: mobile.px2rem(8);
        padding: mobile.px2rem(18) mobile.px2rem(12);
        background: #fff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: mobile.px2rem(12);

        &:last-child {
          margin-bottom: 0;
        }

        .function-content {
          flex: 1;

          .function-title {
            font-weight: 800;
            color: #333333;
            font-size: mobile.px2rem(16);
            line-height: mobile.px2rem(16);
            margin-bottom: mobile.px2rem(4);
            text-align: left;
          }

          .function-desc {
            font-weight: 500;
            font-size: mobile.px2rem(12);
            color: #666;
            text-align: left;
          }
        }

        .function-img-wrap {
          flex-shrink: 0;

          .function-image {
            width: mobile.px2rem(64);
            height: mobile.px2rem(72);
            object-fit: cover;
          }
        }
      }
    }
  }



  // 板块3样式
  .section-3 {
    padding: mobile.px2rem(24) mobile.px2rem(35) mobile.px2rem(44);
    background: #F5F7FB;

    .title-box {
      text-align: center;
      margin-bottom: mobile.px2rem(19);

      .title-text {
        font-size: mobile.px2rem(20);
        font-weight: 800;
        color: #333333;
        margin-bottom: mobile.px2rem(8);
      }

      .title-line {
        font-size: mobile.px2rem(14);
        font-weight: 500;
        color: #333;
      }
    }

    .section3 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: mobile.px2rem(8);

      .section3-item {
        padding: mobile.px2rem(16) 0;
        background: #fff;
        text-align: center;
        box-shadow: 0px 2px 8px 1px rgba(127, 139, 163, 0.12);

        .section3-icon-wrap {
          margin-bottom: mobile.px2rem(8);
          display: flex;
          align-items: center;
          justify-content: center;

          .section3-icon {
            width: mobile.px2rem(24);
            height: mobile.px2rem(24);
            margin-right: mobile.px2rem(4);
          }

          .section3-title {
            font-weight: 800;
            font-size: mobile.px2rem(14);
            color: #333333;
          }
        }



        .section3-desc {
          font-weight: 500;
          font-size: mobile.px2rem(12);
          line-height: mobile.px2rem(12);
          color: #6F6F6F;
        }

        .section3-desc1 {
          margin-bottom: mobile.px2rem(4);
        }
      }
    }
  }


}
</style>